import React, { useContext, useState } from 'react';

// Define the type for the context
interface TeamTableContextType {
  expanded: string[];
  setExpanded: React.Dispatch<React.SetStateAction<string[]>>;
}

const Context = React.createContext<TeamTableContextType | undefined>(
  undefined
);

export const useTeamTableContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      'useTeamTableContext must be used within a TeamTableContextProvider'
    );
  }
  return context;
};

export function TeamTableContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [expanded, setExpanded] = useState<string[]>(['']);
  return (
    <Context.Provider value={{ expanded, setExpanded }}>
      {children}
    </Context.Provider>
  );
}

export default TeamTableContextProvider;
